import { Inject, Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot } from '@angular/router';

import { TranslateService } from '@ngx-translate/core';

import { LoginFacade } from '../+state';
import { SessionService } from '../services';
import Env from '@ridango/core/env';

@Injectable()
export class AuthGuard implements CanActivate {
    constructor(
        @Inject('ENV') private env: Env,
        private session: SessionService,
        private router: Router,
        private translate: TranslateService,
        private loginFacade: LoginFacade
    ) {}

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
        if (
            this.env.DEVICE_CUSTOMER_ENABLED &&
            this.env.ALLOWED_PATHS_FOR_DEVICE_CUSTOMER?.find((path) => state.url.includes(path))
        ) {
            return true;
        }

        if (!this.session.getLoginStatus()) {
            this.loginFacade.logout();
            this.router.navigate([this.translate.currentLang, 'login']);
        }
        return this.session.getLoginStatus();
    }
}
